import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b239fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "main-template",
  class: "main-template"
}
const _hoisted_2 = { class: "contents_con" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "popups" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ToastMessage = _resolveComponent("ToastMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_Loading),
    _hoisted_3,
    (_ctx.toastMessageInfo.isShow)
      ? (_openBlock(), _createBlock(_component_ToastMessage, {
          key: 0,
          message: _ctx.toastMessageInfo.message,
          type: _ctx.toastMessageInfo.type,
          "is-tou": _ctx.toastMessageInfo.isTOU
        }, null, 8, ["message", "type", "is-tou"]))
      : _createCommentVNode("", true)
  ]))
}